import { render, staticRenderFns } from "./LandingModal.vue?vue&type=template&id=63aa8d45&scoped=true"
import script from "./LandingModal.vue?vue&type=script&lang=js"
export * from "./LandingModal.vue?vue&type=script&lang=js"
import style0 from "./LandingModal.vue?vue&type=style&index=0&id=63aa8d45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa8d45",
  null
  
)

export default component.exports